import { RouteTemplate } from '../core-module/types';

export const isBevoorradingsRoute = (template: RouteTemplate) => {
  if (!template || !template.route_template_type_id) {
    return false;
  }

  return template.route_template_type_id === 3;
};
